/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 监管动态----监管文件
 */
import React from 'react';
import { Table } from 'antd';
import { dateFormat } from '../../../../utils/formatter';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import OuterUrlLink from '../../../common/outerUrlLink/OuterUrlLink';
import SearchForm from './announcement/SearchForm';
import { announcementApi } from '../../../../services/regulatoryStatistical';

export default class Announcement extends TableSearch {
    constructor(props) {
        super(props);
        this.server = announcementApi;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            loading: true,
            data: []
        };
    }

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 90
        }, {
            title: '公司简称',
            dataIndex: 'sesName',
            width: 110
        }, {
            title: '时间',
            dataIndex: 'noticeTime',
            render: dateFormat,
            width: 120
        }, {
            title: '标题',
            dataIndex: 'title'
        }, {
            title: '公告类型',
            dataIndex: 'noticeType',
            width: 180
        }, {
            title: '查看',
            dataIndex: 'attachmentUrl',
            width: 150,
            render: (v) => <OuterUrlLink url={v} />
        }];
    };

    render() {
        const { options } = this.props;
        const { pageNum, pageSize, total, data, loading } = this.state;
        return (
            <div>
                <SearchForm options={options} onSearch={this.onSearch}/>

                <Table
                    rowKey="index"
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/riskHint/Announcement.jsx